import { render } from "./LogoSection.vue?vue&type=template&id=4b1f0e53"
const script = {}

import "./LogoSection.vue?vue&type=style&index=0&id=4b1f0e53&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__